const config = require("../config.js");
var g;
module.exports = [
  {
    name: "Tag",
    model: "krunkie_0",
    scale: 6,
    yOff: 6,
    timer: 8000,
    emissive: function (j, k) {
      if (j && k == j.team) {
        return 8729652;
      } else {
        return 4360861;
      }
    },
    onPickup: function (j, k, l, m) {
      if (k && m && m.active) {
        m.active = false;
        if (!(g = j.map.manager.spawnables[m.sid])) {
          return;
        }
        if (l.team == g.team) {
          l.denies++;
          k.send(l.id, "am", ["Denied", 10]);
          j.players.score(l, 10);
        } else {
          j.players.teamScore(l, 1);
          l.confirms++;
          k.send(l.id, "am", ["Confirmed", 25]);
          j.players.score(l, 25);
          if (j.playSound) {
            j.playSound(
              config.networkSounds.indexOf("collect_1"),
              1.2,
              l.sid,
              l.x,
              l.y,
              l.z,
              true,
            );
          }
        }
        k.broadcast("game" + j.sid, "dsp", m.sid);
        delete j.map.manager.spawnables[m.sid];
      }
    },
  },
];
var h = 0;
module.exports.genObj = function (j, k, m, p, q, u, v, w) {
  return {
    i: j,
    x: m,
    y: p,
    z: q,
    team: v,
    timer: w || 0,
    sid: k || h++,
    width: u,
    length: u,
    height: u / 2,
  };
};
